import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root"
})

export class UserManualService {
    constructor(private http: HttpClient) { }

    baseUrl = `${environment.apiUrl}/notification/v1/user-manual`;

    getUserManuals(payload: any) {
        return this.http.post(`${this.baseUrl}/list`, payload);
    }

    getAdminUserManuals(payload: any) {
        return this.http.post(`${this.baseUrl}/admin/list`, payload);
    }

    getUserManualExport(payload: any) {
        return this.http.post(`${this.baseUrl}/admin/list`, payload, { responseType: 'blob' });
    }

    createUserManual(payload: any) {
        return this.http.post(`${this.baseUrl}/create`, payload);
    }

    updateUserManual(id: number, payload: any) {
        return this.http.put(`${this.baseUrl}/${id}`, payload);
    }

    deleteUserManual(id: number) {
        return this.http.delete(`${this.baseUrl}/${id}`);
    }

    downloadUserManual(id: number) {
        return this.http.get(`${this.baseUrl}/${id}/download`, { responseType: 'blob' });
    }
}